import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { EngagementClosingDate } from '../models/engagement-closing-date.model';

export const ConfirmClose = createAsyncThunk(
    'closingDate/confirmClose',
    async (engagementId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        const response = await axios.post(
            `/api/Marketplace/Engagements/${engagementId}/ClosingDate/ConfirmClose`
        );

        if (response.status !== 200) {
            const message =
                response?.response?.data?.title ??
                response?.response?.data?.detail ??
                'An error occurred while confirming the close.';
            createNotification(message, 'error');
            throw new Error('Failed to confirm close');
        }

        createNotification('Close confirmed.', 'success');
        return response.data as EngagementClosingDate;
    }
);
